// Loads the Alpha Ape brand logo once (same-origin, so drawing it onto a
// share-card canvas does NOT taint the canvas — copy/download keep working).
let _img = null;
let _promise = null;

export const loadBrandLogo = () => {
  if (_img && _img.complete && _img.naturalWidth) return Promise.resolve(_img);
  if (_promise) return _promise;
  _promise = new Promise((resolve) => {
    const img = new Image();
    img.onload = () => { _img = img; resolve(img); };
    img.onerror = () => resolve(null);
    img.src = "/alpha-ape.png";
  });
  return _promise;
};

// Draw the Alpha Ape at the top-right of a 1080-wide share card (crisp brand stamp).
export const stampBrandApe = (canvasEl, { height = 188, margin = 60, x = null, y = 44 } = {}) => {
  loadBrandLogo().then((img) => {
    if (!canvasEl || !img) return;
    const ctx = canvasEl.getContext("2d");
    const w = height * (img.width / img.height);
    const px = x != null ? x : canvasEl.width - margin - w;
    ctx.drawImage(img, px, y, w, height);
  });
};
